<template>
  <div class="bg-white pt-32">
    <div class="lg:px-16 md:px-10 px-5 lg:flex md:flex">
      <div class="lg:w-3/4 md:w-7/12 w-full lg:px-6 md:px-2 px-2">
        <div class="w-full">
          <iframe
            width="560"
            height="315"
            src="https://www.youtube.com/embed/TC4HxGNJPbw"
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
            class="w-full newsiframe rounded-lg"
          ></iframe>
        </div>
        <div class="mt-10">
          <div class="flex justify-between items-center">
            <p class="mbr-price font-semibold text-black">
              Title: Lorem ipsum, adipiscing elit.
            </p>
            <img
              src="./../../../assets/images/shareCS.png"
              alt="ShareIcon"
              class="h-6 w-6"
            />
          </div>
          <p class="font-normal lg:text-2xl md:text-xl text-lg mt-2 clr777">
            Phasellus nec feugiat vitae, pharetra
          </p>
          <div class="pt-12">
            <p class="font-normal lg:text-2xl md:text-xl text-lg mt-2 clr777">
              Metus elit euismod pellentesque sapien sollicitudin diam dolor.
              Ultricies ut volutpat sed ultrices justo nibh. Turpis eget natoque
              augue quis. Non sapien tortor mauris, amet vitae, eleifend luctus
              sed. Tortor lobortis vel tortor sollicitudin facilisi. Lectus
              aliquam morbi sed sapien, sed vulputate consectetur maecenas. Ac
              porttitor semper aenean posuere etiam nulla commodo. Tellus risus,
              nisl elit quam. Dictumst ut in vulputate elit, cras.
            </p>

            <p class="font-normal lg:text-2xl md:text-xl text-lg lg:mt-6 mt-2 clr777">
              Sed convallis vitae vivamus laoreet massa velit mauris faucibus.
              Placerat quisque amet scelerisque iaculis cum eget adipiscing.
              Tortor lobortis vel tortor sollicitudin facilisi. Lectus aliquam
              morbi sed sapien, sed vulputate consectetur maecenas. Ac porttitor
              semper aenean posuere etiam nulla commodo. Tellus risus, nisl elit
              quam. Nisl nulla faucibus ultricies feugiat urna, aenean nunc.
              Amet at sed sagittis nisi, sit est nulla bibendum commodo. Enim
              egestas vel blandit fringilla eget mi, ultrices habitant eu. Sed
              convallis vitae vivamus laoreet massa velit mauris faucibus.
            </p>
          </div>
          <div class="lg:pt-12 md:pt-8 pt-4">
            <p class="mbr-price font-semibold text-black">Linked this Video?</p>
            <base-button
              outline
              type="primary"
              class="
                md:px-8
                lg:px-8
                px-6
                md:py-2
                lg:py-2
                py-1
                fs16700
                border-2
                mt-6
              "
              >Read more</base-button
            >
          </div>
        </div>
      </div>
      <div class="lg:w-1/4 md:w-5/12 w-full lg:px-6 md:px-2 px-2 lg:mt-0 md:mt-0 mt-5">
        <div class="w-full pb-6" v-for="(item, index) in 5" :key="index">
          <img
            src="./../../../assets/images/news4.jpg"
            alt="News"
            class="w-full h-52 rounded-lg"
          />
          <p class="font-bold text-xl text-black mt-2 px-2">
            News Title Lorem Ipsum
          </p>
          <div class="mt-1 flex px-2">
            <p class="text-xs clr777 font-normal">1 Hour ago</p>
            <p class="text-xs clr777 font-normal ml-6">200 views</p>
          </div>
        </div>
      </div>
    </div>
    <div class="bge3ceff-opa rounded-t-5555 mt-12 relative zindex1">
      <div class="absolute -top-56 right-8 md:block lg:block hidden">
        <img
          src="./../../../assets/images/bg-des/footer-bg.svg"
          alt="bg-polygon"
          class="h-full"
        />
      </div>
      <DownloadApp />
      <Footer />
    </div>
  </div>
</template>
<script>
import DownloadApp from "../../home/components/DownloadApp.vue";
import Footer from "../../Footer.vue";
export default {
  components: {
    DownloadApp,
    Footer,
  },
};
</script>
